import {
  ChangeDetectorRef,
  Component,
  Input
} from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { KENDO_DIALOGS, WindowRef } from '@progress/kendo-angular-dialog'
import { interval } from 'rxjs'

import { CommonModule, NgIf } from '@angular/common'
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { DropDownFilterSettings, KENDO_MULTISELECT } from '@progress/kendo-angular-dropdowns'
import { KENDO_GRID, KENDO_GRID_EXCEL_EXPORT, KENDO_GRID_PDF_EXPORT } from '@progress/kendo-angular-grid'
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators'
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs'
import { PHONE_MASK, toPhoneDigits } from '../../@theme/pipes/phone.pipe'
import { LabelDirective } from '@progress/kendo-angular-label'
import { ToastrService } from 'ngx-toastr'
import { ClientServices } from '../../@theme/services/clients.service'
import { UserStateService } from '../../@theme/services/user-state.service'
import { UserService } from '../../@theme/services/user.service'
import { AuthservicesService } from '../../auth/services/authservices.service'
import { UserInfo } from '../../models/userModels'
import { validateemailval } from '../../modules/auth/models/auth.model'
@Component({
  selector: 'gd-dashrep',
  templateUrl: './authrepdash.component.html',
  styleUrls: ['./authrepdash.component.css'],
  providers: [WindowRef],
  imports: [
    CommonModule,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_GRID_PDF_EXPORT,
    KENDO_GRID_EXCEL_EXPORT,
    KENDO_INDICATORS,
    KENDO_DIALOGS,
    KENDO_BUTTONS,
    KENDO_MULTISELECT,
    FormsModule,
    ReactiveFormsModule,
    LabelDirective,
    NgIf,
  ]
})
export class AuthRepDashComponent {
  public phoneMask = PHONE_MASK
  public selectedRoleValues: string[] = [];
  public accountinfo: string = '';
  public selectedValues: string[] = ['REP'];
/*   @ViewChild('select') selectElem: NbSelectComponent */
  @Input() branchlist: any = [];
  @Input() dialogMode: 'edit' | 'create' = 'create';
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains',
  };
  submitted = false
  showMessages: string
  firstname: string
  private repId: number
  public selectedchanges = "";
  private usernameManualEdit = false;
  roles$: [] = []
  branchlist$: [] = []
  branchrolelist$: string[] = []
  productlist$: any[] = []
  public emailIdList: any[]
  approveProductlist$: any[] = []
    public mySelection: number[] = []
  public mySelectionemailTypes: number[] = []
  public mySelectionRoleTypes: string[] = []
  public showRepBranchlist = false
  public showBranchSelection = false
  public showBranchAccessNonManager = false
  public showProductSelection = false
  public mySelectionProducts: [] = []
  public mySelectionApproveProducts: number[] = []
  errors: string[] = []
  public querystringreg = window.location.href.toLowerCase().includes('register');
  messages: string[] = []
  user: any = {}
  registerForm: UntypedFormGroup
  buttontext: string
  private getsubstring: boolean
  public mySelectionBranchLinks: number[] = []
  public mySelectionroleLinks: string[] = []
  private excludedRoles = new Set([
    'ADMIN',
    'INSURANCE PRINCIPAL',
    'ADVISOR PRINCIPAL',
    'TRADING USER',
    'SUPERUSER',
    'HOME OFFICE USER',
    'ADVISOR USER',
    'TRADING PRINCIPAL',
    'INSURANCE USER',
    'COMPLIANCE USER',
    'COMPLIANCE PRINCIPAL',
//    'BRANCH MANAGER',
    'null',
  ]);
  selectedItems: any[] = []; // Array for MultiSelect values
  constructor(
    private windowRef: WindowRef,
    protected cd: ChangeDetectorRef,
    public fb: UntypedFormBuilder,
    protected router: Router,
    private ur: UserService,
    private auth: AuthservicesService,
    private toastrService: ToastrService,
    private stateService: UserStateService,
    private route: ActivatedRoute,
    private getbranchservice: ClientServices,
  ) {

    this.ur.getRoleList().subscribe((response) => {
      this.roles$ = response.filter(role => !this.excludedRoles.has(role.name));
    });
    
    // Load product list for branch managers
    this.ur.getproductList().subscribe((response) => {
     // console.log(JSON.stringify(response));
      this.productlist$ = response;
    //  this.approveProductlist$ = response;
    });
    
    // Default button text, will be updated in ngOnInit
    this.buttontext = 'CREATE USER';
    
    this.showRepBranchlist = true
    this.getsubstring = true
    this.getBranchlist()
    
    this.registerForm = this.fb.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      username: ['', Validators.required],
      phonenumber: ['', Validators.compose([Validators.required, Validators.pattern(/^(\+?1)?[\s\-\.\(\)]*(\d[\s\-\.\(\)]*){10}$/)])],
      roles: ['', Validators.required],
      branchlist: [],
      products: [],
      approveProducts: [false],
      cbReceiveBranchRepEmails: [false],
      repId: [null],
      email: new UntypedFormControl(
        '',
        Validators.compose([Validators.required]),
      ),
    })
    
    this.route.queryParams.subscribe(params => {
      if (params['repId']) {
        this.repId = +params['repId'];
        this.registerForm.patchValue({ repId: this.repId }, { emitEvent: false });
      }
    });
    this.registerForm.get('firstname')?.valueChanges.subscribe(() => this.updateUsername());
    this.registerForm.get('lastname')?.valueChanges.subscribe(() => this.updateUsername());
    this.registerForm.get('username')?.valueChanges.subscribe((value: string) => {
      this.usernameManualEdit = true;
      if (value && /\s/.test(value)) {
        this.registerForm.get('username')?.setValue(value.replace(/\s+/g, ''), { emitEvent: false });
      }
    });
    
    // Watch for role changes to show/hide branch and product selections
    this.registerForm.get('roles')?.valueChanges.subscribe((selectedRoles) => {
      this.onRoleChange(selectedRoles);
    });
    
    this.cleanSelectedItems()
    /*     this.registerForm.get('username')?.valueChanges.pipe(debounceTime(300)).subscribe(() => this.usernameEdited = true); */
  }

 getEmailbyProductTypeId(Id: string) {
    this.ur.getUserIdbyProductTypeId(Id).subscribe((r) => {
      const prodtype = r.map(function (p: any) {
        return p.productType
      })
      const emailtype = r.map(function (e: any) {
        return e.emailTypeId
      })
      const emailId = r.map(function (e: any) {
        return e.emailId
      })
      this.mySelection = prodtype
      this.mySelectionemailTypes = emailtype
      this.emailIdList = emailId
    })
  }
    public onSelectedKeysChangeProducts(e: any) {
    this.mySelection = e;
  }
    public onSelectedKeysChangeEmails(e: any) {
    this.mySelectionemailTypes = e;
  }
  get f() {
    return this.registerForm.controls
  }
  cleanSelectedItems() {
    this.selectedItems = this.selectedItems.filter(item => item != null && item.trim() !== '');
  }

  onSelectionChange(event: any) {
    this.cleanSelectedItems();
  }
  getBranchlist(): void {
    this.getbranchservice.RetrieveRepBranchList().subscribe((response) => {
      if (response !== undefined) {
        this.branchrolelist$ = response
      }
    })
  }
  getBranchlinks(): void {
    const email = this.registerForm.controls['email'].value
    if (!email) return
    this.getbranchservice
      .RetrieveRepBranchLink({ Email: email })
      .subscribe((response) => {
        if (response !== undefined) {
          this.mySelectionBranchLinks = response
          this.registerForm.patchValue({ branchlist: response }, { emitEvent: false })
          this.cd.markForCheck()
        }
      })
  }

  ngOnInit(): void {
    // Set button text based on dialog mode or query params
    if (this.dialogMode === 'edit') {
      this.buttontext = 'UPDATE USER';
    } else if (this.route.snapshot.queryParams['edit']) {
      this.buttontext = 'UPDATE USER';
    } else {
      this.buttontext = 'CREATE USER';
    }

    if (
      this.stateService.currentUserInfo &&
      this.stateService.currentUserInfo.email
    ) {
      const editUser = this.stateService.currentUserInfo;
      
      // Set basic form values from the state data
      this.registerForm.patchValue({
        firstname: editUser.firstName || '',
        lastname: editUser.lastName || '',
        email: editUser.email || '',
        phonenumber: toPhoneDigits((editUser.phoneNumber || '').replace(/^\+1/, '')),
      }, { emitEvent: false });

      const phoneCtrl = this.registerForm.get('phonenumber');
      if (phoneCtrl) {
        phoneCtrl.markAsTouched();
        phoneCtrl.updateValueAndValidity();
      }
      this.cd.markForCheck();
      
      // Set username based on first/last name
      if (editUser.firstName && editUser.lastName) {
        const username = `${editUser.firstName.replace(/\s+/g, '')}.${editUser.lastName.replace(/\s+/g, '')}`;
        this.registerForm.patchValue({ username }, { emitEvent: false });
      }
      
      // Fetch full user data from API to get roles, branches, and products
      this.auth
        .getUserByEmailSelect(editUser.email)
        .subscribe((response) => {
          if (response) {
            //console.log('Raw API response:', JSON.stringify(response));
            
            // Pre-select roles if they exist
            if (response.roles && response.roles.length > 0) {
          //    console.log('Setting roles:', response.roles);
              this.registerForm.patchValue({ roles: response.roles }, { emitEvent: false });
              this.mySelectionroleLinks = response.roles;
              // Trigger role change to show/hide branch/product sections
              this.onRoleChange(response.roles);
            }
            
            this.getBranchlinks();
            
            // Fetch products using user ID (same pattern as edituser.component)
            const userId = response.id || response.Id || response.userId || response.UserId;
          //  console.log('User ID for product lookup:', userId);
            if (userId) {
              this.getEmailbyProductTypeId(userId);
            }
            
            // Set approveProducts checkbox
            if (response.approveProducts !== undefined) {
              this.registerForm.patchValue({ approveProducts: response.approveProducts }, { emitEvent: false });
            }
            
            this.cd.detectChanges();
          }
        });
      
      // Clear the state after using it
      this.stateService.currentUserInfo = null;
    }
    
    // Auto-generate username when first/last name changes
    this.registerForm.valueChanges.subscribe(values => {
      if (values.firstname && values.lastname) {
        const username = `${values.firstname}.${values.lastname}`;
        if (this.registerForm.get('username')?.value !== username) {
          this.registerForm.patchValue({ username }, { emitEvent: false });
        }
      }
    });

  }


  register(): void {
    if (this.registerForm.invalid) {
      return;
    }
    const rawFormData = this.registerForm.value;
    this.user = this.cleanFormData(rawFormData);
    
    // Clean phone number - remove brackets, spaces, dashes, and other formatting
    if (this.user.phonenumber) {
      this.user.phonenumber = this.user.phonenumber.replace(/[\(\)\s\-\.]/g, '');
      if (!this.user.phonenumber.startsWith('+1')) {
        this.user.phonenumber = this.user.phonenumber.startsWith('1')
          ? `+${this.user.phonenumber}`
          : `+1${this.user.phonenumber}`;
      }
    }
    
    // Handle branchlist - use the form control value which contains selected branch IDs
    const selectedBranches = this.registerForm.get('branchlist')?.value;
    if (selectedBranches && Array.isArray(selectedBranches) && selectedBranches.length > 0) {
      this.user.branchlist = selectedBranches.map(item => item.toString());
    } else {
      this.user.branchlist = [];
    }
    
    // Add products if branch manager
    if (this.showProductSelection) {
      const prodtypelist = this.mySelection.map((obj) => ({ productTypeId: obj }))
      this.user.userlist = prodtypelist;
      
      // Handle approveProducts checkbox - backend expects bool?, send true/false/null
      const approveProductsValue = this.registerForm.get('approveProducts')?.value;
      this.user.approveProducts = approveProductsValue === true ? true : false;
    } else {
      // Remove products fields if not branch manager
      delete this.user.userlist;
      delete this.user.approveProducts;
    }
    this.errors = this.messages = []
    this.submitted = true
    console.log('Sending data:', JSON.stringify(this.user));
    this.auth.registerRep(this.user).subscribe((result: any) => {
      this.submitted = false
      if (result.succeeded) {
        this.showToast('success', 'User created successfully');
        setTimeout(() => {
            if (this.windowRef && typeof this.windowRef.close === 'function') {
          this.windowRef.close();
            }
        }, 5000);
      } else {
        this.showToast('warning', 'Something went wrong');
      }
    })
  }
  private cleanFormData(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.filter(item => item !== '' && item !== null && item !== undefined);
    } else if (typeof obj === 'object' && obj !== null) {
      return Object.fromEntries(
        Object.entries(obj)
          .filter(([_, value]) =>
            value !== '' &&
            value !== null &&
            value !== undefined &&
            !(Array.isArray(value) && value.length === 0)
          )
          .map(([key, value]) => [key, this.cleanFormData(value)])
      );
    }
    return obj;
  }

  showToast(status: 'success' | 'error' | 'info' | 'warning', message: string) {
    switch (status) {
      case 'success':
        this.toastrService.success(message, 'Success');
        break;
      case 'error':
        this.toastrService.error(message, 'Error');
        break;
      case 'info':
        this.toastrService.info(message, 'Info');
        break;
      case 'warning':
        this.toastrService.warning(message, 'Warning');
        break;
      default:
        this.toastrService.show(message);
        break;
    }
  }

  onRoleChange(selectedRoles: any) {
    console.log('onRoleChange called with:', selectedRoles);
    console.log('Available roles$:', this.roles$);
    
    // Handle if selectedRoles is not an array or is empty
    let rolesArray: any[] = [];
    if (typeof selectedRoles === 'string') {
      rolesArray = [selectedRoles];
    } else if (Array.isArray(selectedRoles)) {
      rolesArray = selectedRoles.filter(r => r && r.trim() !== ''); // Filter out empty strings
    } else if (selectedRoles) {
      rolesArray = [selectedRoles];
    }
    
    if (rolesArray.length === 0) {
      this.showBranchSelection = false;
      this.showProductSelection = false;
      console.log('No roles selected, hiding everything');
      return;
    }

    // Convert role IDs (GUIDs) to role names by looking them up in roles$ array
    const roleNames: string[] = [];
    rolesArray.forEach(roleId => {
      console.log('Processing role ID:', roleId);
      
      // Look up the role by ID in the roles$ array
      const role: any = this.roles$.find((r: any) => r.id === roleId);
      console.log('Found role object:', role);
      
      if (role && role.name) {
        roleNames.push(role.name.toUpperCase());
      }
    });

    console.log('Role names extracted:', roleNames);

    const hasBranchManager = roleNames.includes('BRANCH MANAGER');
    const hasBranchAccess = roleNames.includes('BRANCH ACCESS NON MANAGER');
    const hasRep = roleNames.includes('REP');

    console.log('hasBranchManager:', hasBranchManager, 'hasBranchAccess:', hasBranchAccess, 'hasRep:', hasRep);

    // Show branch selection for BRANCH MANAGER or BRANCH ACCESS NON MANAGER, but NOT if REP is selected
    this.showBranchSelection = (hasBranchManager || hasBranchAccess) && !hasRep;

    // Show "Receive all Emails for Branch Reps" only for BRANCH ACCESS NON MANAGER
    this.showBranchAccessNonManager = hasBranchAccess && !hasRep;

    // Show product selection ONLY for BRANCH MANAGER and NOT if REP is selected
    this.showProductSelection = hasBranchManager && !hasRep;

    console.log('FINAL - showBranchSelection:', this.showBranchSelection, 'showProductSelection:', this.showProductSelection);

    if (this.showBranchSelection) {
      this.getBranchlist()
      this.getBranchlinks()
    }
    
    // Trigger change detection
   // this.cd.detectChanges();
  }

  change(event: any) {
    if (event === 'BRANCH ACCESS NON MANAGER') {
      const observable1 = interval(400)
      const observable2 = interval(300)
      this.showRepBranchlist = true

      const subscription = observable1.subscribe(() => this.getBranchlist())
      const childSubscription = observable2.subscribe(() =>
        this.getBranchlinks(),
      )
      subscription.add(childSubscription)
      setTimeout(() => {
        subscription.unsubscribe()
      }, 1000)
      this.showRepBranchlist = true
    }
    if (event !== 'BRANCH ACCESS NON MANAGER' && this.getsubstring !== true) {
      this.showRepBranchlist = false
    }
  }
  back() {
    location.pathname = '/'
  }
  private updateUsername() {
    if (!this.usernameManualEdit) {
      const firstname = this.registerForm.get('firstname')?.value;
      const lastname = this.registerForm.get('lastname')?.value;

      if (firstname && lastname) {
        const username = `${firstname.replace(/\s+/g, '')}.${lastname.replace(/\s+/g, '')}`;
        this.registerForm.patchValue({ username }, { emitEvent: false });
      }
    }
  }

}
